/* Grid collage section
 * Authored as a custom element (Web Component).
 * Lazy media: each tile image keeps its real source in data-src / data-srcset
 * and only swaps it into the <img> on the first user interaction
 * (touch / scroll / pointer / key / wheel), deferring requests until needed.
 */
if (!customElements.get('grid-collage')) {
  class GridCollage extends HTMLElement {
    constructor() {
      super();
      this.images = Array.from(this.querySelectorAll('img[data-src]'));
      this.loaded = false;
      this.interactionEvents = ['pointerdown', 'touchstart', 'keydown', 'mousemove', 'wheel', 'scroll'];
      this.handleFirstInteraction = this.handleFirstInteraction.bind(this);
    }

    connectedCallback() {
      if (this.images.length === 0) return;
      this.interactionEvents.forEach((evt) =>
        window.addEventListener(evt, this.handleFirstInteraction, { once: true, passive: true })
      );
    }

    disconnectedCallback() {
      this.interactionEvents.forEach((evt) =>
        window.removeEventListener(evt, this.handleFirstInteraction)
      );
    }

    handleFirstInteraction() {
      if (this.loaded) return;
      this.loaded = true;

      this.images.forEach((img) => {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        if (img.dataset.src) img.src = img.dataset.src;
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-src');
      });

      this.interactionEvents.forEach((evt) =>
        window.removeEventListener(evt, this.handleFirstInteraction)
      );
    }
  }

  customElements.define('grid-collage', GridCollage);
}
